import React, { useContext, useEffect } from "react";
import styled from "styled-components";
import Header from "Components/Header";
import Footer from "Components/Footer";
import SignIn from "Components/SignIn";
import AuthContext from "Context/Auth/AuthContext";

let kakaoKey;
kakaoKey = process.env.REACT_APP_KAKAO_JS_KEY;

const Login = (props) => {
  const authContext = useContext(AuthContext);
  const { login, loading, isAuthenticated } = authContext;

  useEffect(() => {
    const { Kakao } = window;
    Kakao.init(kakaoKey);
    Kakao.Auth.createLoginButton({
      container: "#KAKAO-LOGIN",
      size: "large",
      persistAccessToken: false,
      success: function (response) {
        login(response.access_token);
      },
      fail: function (error) {
        console.log(error);
      },
    });
    return () => Kakao.cleanup();
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    const { from } = props.location.state || { from: { pathname: "/" } };
    if (isAuthenticated) {
      props.history.push(from);
    }
    // eslint-disable-next-line
  }, [isAuthenticated]);

  return (
    <Container>
      <Header />
      <SignIn loading={loading} />
      <Footer />
    </Container>
  );
};

export default Login;

const Container = styled.div`
  position: relative;
  min-height: 100vh;
  padding-bottom: 250px;
`;
